(function () {
  class DrgSuitCustomizer extends HTMLElement {
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('[data-drg-customizer-option]'));
      this.panel = this.querySelector('[data-drg-customizer-panel]');
      this.fields = Array.from(this.querySelectorAll('[data-drg-customizer-field]'));

      this.options.forEach((option) => {
        option.addEventListener('change', () => this.update());
      });

      this.update();
    }

    update() {
      const selected = this.options.find((option) => option.checked);
      const enabled = selected && selected.value === 'Yes';

      if (this.panel) {
        this.panel.hidden = !enabled;
      }

      this.fields.forEach((field) => {
        field.disabled = !enabled;
        if (!enabled) {
          field.value = '';
        }
      });
    }
  }

  if (!customElements.get('drg-suit-customizer')) {
    customElements.define('drg-suit-customizer', DrgSuitCustomizer);
  }
})();
